'use client';
import ModalForm from '@/components/Modal/Modal';
import Image from 'next/image';
import { ReactNode, useState } from 'react';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';

interface HeroBlockCustomProps {
  color?: 'violet' | 'green' | 'blue';
  title: ReactNode | SerializedEditorState;
  link: { url: string; alt?: string } | string; // Підтримка об’єкта з Payload або рядка
  linkMobile: { url: string; alt?: string } | string; // Підтримка об’єкта з Payload або рядка
  CTAText: ReactNode | SerializedEditorState;
  CTATextBtn: string;
  CTATag: string;
}

export default function HeroBlockWithPerson({
  color = 'green',
  title,
  link,
  linkMobile,
  CTAText,
  CTATextBtn,
  CTATag,
}: HeroBlockCustomProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const backgroundColorClass =
    {
      green: 'custom-gradient-green-btn',
      blue: 'custom-gradient-blue-btn',
      violet: 'custom-gradient-violet-btn',
    }[color] || 'custom-gradient-green-btn';

  const extractTextFromSerializedState = (serializedState: SerializedEditorState): string => {
    const extractText = (node: any): string => {
      if (node.text) {
        return node.text;
      }
      if (node.children && Array.isArray(node.children)) {
        return node.children.map(extractText).join(' ');
      }
      return '';
    };

    if (serializedState && typeof serializedState === 'object' && 'root' in serializedState) {
      return extractText(serializedState.root);
    }
    return '';
  };

  const mobileTitle =
    title && typeof title === 'object' && 'root' in title
      ? extractTextFromSerializedState(title)
      : typeof title === 'string'
        ? title
        : '';

  console.log('Debug: mobileTitle', mobileTitle); // Додано для діагностики

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);
  return (
    <>
      <div
        data-meta="HeroBlockCustomEnglish"
        className="relative container mx-auto px-4 sm:px-6 lg:px-8 mb-8 lg:mb-14"
      >
        <div className="sm:px-6 max-w-7xl mx-auto  lg:mt-12 lg:px-8">
          <div className="relative">
            <div className="flex lg:hidden text-center relative flex-col justify-end p-8 pb-16">
              <div className="text-3xl font-bold text-white sm:text-5xl">
                {mobileTitle ? (
                  <CustomRichText data={mobileTitle} tag="div" className="text-white" />
                ) : (
                  <div className="text-white">Заголовок відсутній</div>
                )}
              </div>
            </div>
            <Image
              width={1680}
              height={700}
              alt={typeof link === 'object' ? link.alt || '' : ''}
              src={typeof link === 'object' ? link.url || '' : link || ''}
              className="hidden lg:block object-cover w-full h-full max-w-7xl"
            />
            <Image
              width={800}
              height={550}
              alt={typeof linkMobile === 'object' ? linkMobile.alt || '' : ''}
              src={typeof linkMobile === 'object' ? linkMobile.url || '' : linkMobile || ''}
              className="lg:hidden object-cover w-full h-full max-w-7xl"
            />
            <div className="hidden lg:flex absolute top-12 xl:top-24  right-0 xl:right-12   flex-col justify-end p-2">
              <div className="text-2xl max-w-md font-bold text-white sm:text-5xl ">
                <CustomRichText data={title} tag="div" className="text-white" />
              </div>
            </div>
            <div className=" hidden lg:block absolute top-[90%] right-0">
              <div className="flex md:gap-2 xl:gap-12 items-center">
                <div className="text-white text-xs md:text-sm xl:text-base">
                  <CustomRichText data={CTAText} tag="div" className="text-white" />
                </div>
                <button
                  onClick={openForm}
                  className={`uppercase ${backgroundColorClass} rounded-full px-8 py-2.5 text-center text-sm font-fixel font-bold text-white shadow-sm focus-visible:outline`}
                >
                  <CustomRichText data={CTATextBtn} tag="div" className="text-white" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:hidden mt-4 font-fixel py-4 text-white text-md rounded-3xl flex flex-col justify-center items-center gap-4">
          Цікавить вивчення іноземної мови?
          <button
            onClick={openForm}
            className={`${backgroundColorClass} uppercase text-white rounded-full px-8 py-2.5 text-center text-sm font-fixel font-bold focus-visible:outline`}
          >
            <CustomRichText data={CTATextBtn} tag="div" className="text-white" />
          </button>
        </div>
      </div>

      {isFormOpen && (
        <ModalForm
          closeForm={closeForm}
          btnMeta={{
            tag: CTATag,
          }}
          color={color}
        />
      )}
    </>
  );
}
